import PageLayout from "@/components/base/page-layout";
import Campaigns from "@/components/campaigns";
import withErrorBoundary from "@/components/hoc/with-error-boundary";

const CampaignsPage = () => {
  return (
    <PageLayout title="Campaigns">
      <Campaigns />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "CampaignsPage" })(CampaignsPage);
